// import hooks
import { useQuery, UseQueryOptions } from 'react-query';

// import queries & mutations
import { getWorkAgreements } from 'RestAPIs/employees/leave-requests';

// import types
import {
  EmployeeWorkAgreementProps,
  QueryFnType,
  QueryKeyType
} from './useGetEmployeeWorkAgreements.types';

const useGetEmployeeWorkAgreements = (
  { startDate, endDate, employeeId }: EmployeeWorkAgreementProps,
  queryOptions?: UseQueryOptions<
    QueryFnType,
    unknown,
    QueryFnType,
    QueryKeyType
  >
) => {
  const { data, isFetching, isError, refetch } = useQuery(
    ['employeeWorkAgreements', employeeId, startDate, endDate],
    async () => {
      const { data } = await getWorkAgreements({
        startDate,
        endDate,
        employeeId
      });
      return data;
    },
    {
      enabled: !!startDate && !!endDate && !!employeeId,
      ...queryOptions
    }
  );
  return { data, isFetching, isError, refetch };
};

export default useGetEmployeeWorkAgreements;
